export default __webpack_public_path__ + "static/media/architekten.9ffd6df8.webp";